import { ReactNode } from "react";
import { Grid2 as Grid } from "@mui/material";

import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";


export interface ITwoColumnToSingleColumnProps {
    leftChildren: ReactNode,
    rightChildren: ReactNode,
    gridLeftAlignment?: 'flexStart' | 'flexEnd' | 'center',
    gridRightAlignment?: 'flexStart' | 'flexEnd' | 'center',
    colLeft?: number,
    colRight?: number
}

export const TwoColumnToSingleColumn = (props: ITwoColumnToSingleColumnProps) => {
    // -------------------------------------------
    // PROPS
    const { leftChildren, rightChildren, gridLeftAlignment, gridRightAlignment, colLeft, colRight } = props;

    // Optional configuration of the alignment for each of the grid items
    let leftAlignment = 'stretch';
    let rightAlignment = 'stretch';
    if (baseDefinedAndNotNullNarrowing(gridLeftAlignment)) { leftAlignment = gridLeftAlignment!; }
    if (baseDefinedAndNotNullNarrowing(gridRightAlignment)) { rightAlignment = gridRightAlignment!; }

    // Optional configuration of the ratio of the two columns above the MD size
    let numMdColLeft = 6;
    let numMdColRight = 6;
    if (baseDefinedAndNotNullNarrowing(colLeft)) { numMdColLeft = colLeft!; }
    if (baseDefinedAndNotNullNarrowing(colRight)) { numMdColRight = colRight!; }

    return (
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={2}>
            <Grid size={{ xs: 12, md: numMdColLeft }} alignSelf={leftAlignment}>
                {leftChildren}
            </Grid>
            <Grid size={{ xs: 12, md: numMdColRight }} alignSelf={rightAlignment}>
                {rightChildren}
            </Grid>
        </Grid>
    )
}

export interface IThreeColumnToSingleColumnProps {
    leftChildren: ReactNode,
    middleChildren: ReactNode,
    rightChildren: ReactNode,
    gridLeftAlignment?: 'flexStart' | 'flexEnd' | 'center',
    gridMiddleAlignment?: 'flexStart' | 'flexEnd' | 'center',
    gridRightAlignment?: 'flexStart' | 'flexEnd' | 'center',
    colLeft?: number,
    colMiddle?: number,
    colRight?: number
}